// #1080 案件詳細のスマホ用固定応募バー。
// 本文側(右カラム)の応募ボタンが画面内に入ったら、同じボタンが二重に見えないように
// 固定バーを .is-hidden(下へスライド+フェード)にし、見えなくなったら戻す。
export function initStickyCta(root = document) {
  const bar = root.querySelector('.job-detail_mobile-bar')
  const inlineCta = root.querySelector('.job-detail_aside .job-detail_cta')
  if (!bar || !inlineCta || bar.dataset.stickyCtaBound) return
  if (!('IntersectionObserver' in window)) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        bar.classList.toggle('is-hidden', entry.isIntersecting)
      })
    },
    // ボタン全体ではなく一部が見え始めた時点で切り替える
    { threshold: 0.2 }
  )
  observer.observe(inlineCta)
  bar.dataset.stickyCtaBound = 'true'
}
